import { render, staticRenderFns } from "./ViewMethodRecruitment.vue?vue&type=template&id=651cd00e&"
import script from "./ViewMethodRecruitment.vue?vue&type=script&lang=js&"
export * from "./ViewMethodRecruitment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports